<template>
  <div>
    <el-drawer @reload="$reloadHandle" title="已派师傅" size="40%" :before-close="handleClose" :visible.sync="drawer"
      direction="rtl" append-to-body custom-class="demo-drawer" ref="drawer" class="details2">

      <div class="demo-drawer__content">



        <template>
          <div id="containt">



                <div class="grid-height" style="height: calc(100vh - -60px);">
                  <vxe-grid :stripe="true" ref="table-m1" v-bind="gridData" show-overflow height="100%" border="default"
                    :row-config="{ isHover: true }" @resizable-change="$vxeTableUtil.onColumnWitchChange"
                    @custom="$vxeTableUtil.customHandle">
                    <template #form>
                      <div class="clearfix screen-btns">
                        <!-- <div class="fl">
                          <vxe-button status="primary" class="button-sty" icon="el-icon-plus"
                            @click="openEditDialog">新增</vxe-button>
                        </div> -->
                        <div class="fr">
                          <!-- <vxe-button icon="el-icon-brush" class="button-sty" @click="resetEvent" type="text" status="primary"
                    plain>重置</vxe-button> -->
                          <vxe-button status="warning" icon="el-icon-search" class="button-sty"
                            @click="searchEvent">搜索</vxe-button>
                        </div>
                      </div>
                      <vxe-form ref="form" class="screen-box" title-width="92px" title-align="right" :data="requestParam"
                        @submit="searchEvent" @reset="searchEvent">
                        <vxe-form-item title="工程师姓名:" field="orderTypeName">
                          <template v-slot>
                            <el-input v-model="formData.labelName" size="small" clearable />
                          </template>
                        </vxe-form-item>
                      </vxe-form>
                    </template>
                    <template #pager class="pager_left">
                      <pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
                    </template>
                  </vxe-grid>
                </div>


          </div>
        </template>

      </div>
    </el-drawer>

    <!-- 关闭弹窗 -->

  </div>
</template>
<script>
import request from "@/router/axios";
// import api from "../../api/projectApi";




import { tableOption } from '@/const/crud/admin/tenant';
import { initVxeTable } from '@/const/crud/admin/table';
import pager from '@/components/pager/index.vue'
import api from "@/api/projectApi";
import { indexPageMixins } from "@/mixins/tabChang";

export default {
  inject: ['reload'],
  name: 'edit',
  props: ['multi', 'param'],
  components: { pager },
  mixins: [indexPageMixins],
  created() {
    this.dataId = this.param ? this.param.orderId ? this.param.orderId : '' : ''
    this.showInRemark = this.param ? this.param.showInRemark ? this.param.showInRemark : '' : ''
    this.orderRemarkData.id = this.param ? this.param.orderId ? this.param.orderId : '' : ''
  },
  data() {
    return {
      show3: false,
      showInRemark: "",
      dataId: '',
      form2: {
        desc: '',
        name: "",
      },
      showOrderPop: false,
      isSendApp: false,
      drawer: true,


      spPartsApplyLineDTOList: [{
        partsCode: '1'

      }],
      dispatchStats: [],
      orderRemarkData: {},



      total: 0,
      requestParam: {
        searchCount: false,  // 是否分页
        current: 1,  // 当前页面
        size: 0,  // 页面数据量
        labelName: null,  // 来源名称
      },
      formData: {
        labelName: null,  // 来源名称
      },
      pageSizes: [20, 50, 100],
      gridData: {},
      showEdit: false,
      activeName: 'second',
      dataId: 0,

      column: [
        { type: 'seq', title: '序号', width: 60, resizable: false, fixed: 'left' },
        { title: '工程师账号', field: 'maxAmount', width: 100,},
        { title: '工程师姓名', field: 'labelName', width: 100, },
        { title: '派师傅时间', field: 'createTime', width: 150, },
        { title: '操作历史记录', field: 'createBy', width: 130, },


      ],
    }
  },
  watch: {
    total(newVal, oldVal) {
      this.$refs.pager.tableDataTotal = newVal
    }
  },
  mounted() {
    this.getData();
    this.getDispatch();
  },
  methods: {
    // 刷新
    flushed() {
      this.$refs['table-m1'].commitProxy('reload');
    },

    // 加载table数据
    getTableData() {
      let tableOption = {
        vue: this,
        tableRef: 'table-m1',
        path: api.slPriceLabel.getPageDataUrl,
        param: this.requestParam,
        method: 'post',
        columns: this.column
      };
      this.gridData = initVxeTable(tableOption);
      this.flushed()
    },

    // 分页功能
    changeTablePage(page, flag) {
      this.requestParam.size = page.pageSize
      this.requestParam.current = page.currentPage
      this.requestParam.searchCount = flag
      this.getTableData()
    },

    handleClick(tab, event) {
      console.log(tab, event, 'handleClick');
      this.flushed()
    },

    updateChange() {
      this.flushed()
    },

    // 搜索
    searchEvent() {
      this.$objCopy(this.formData, this.requestParam)
      this.$refs.pager.clearStoreTableDataTotal()
      this.requestParam.current = 1
      this.requestParam.searchCount = false
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },

    //
    openEditDialog(id) {
      console.log(id,"选择的工程师");
      this.drawer = false;
      this.$emit('closedispatchedMaster', false)
    },

    getData() {
      //获取对应的工单信息
      request({
        url: api.soOrder.getDataUrl,
        method: 'post',
        data: {
          id: this.dataId
        },
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        this.formData = response.data.data;
      })
    },
    getDispatch() {
      request({
        url: api.basDispatchStat.getList,
        method: 'post',
        data: { showInRemark: this.showInRemark },
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        this.dispatchStats = response.data.data
      })
    },
    handleClose() {
      this.drawer = false;
      this.$emit('closedispatchedMaster', 0)
    }
  }
}
</script>
<style lang="scss" scoped>
.zhiPai {
  color: rgb(33, 150, 243);
  text-decoration: underline;
}

.details2 {


  ::v-deep .el-drawer .el-drawer__body {
    padding: 0 16px;
    background-color: #fff;
    position: relative;
    overflow: hidden;
  }

  ::v-deep .el-drawer .el-drawer__header {
    background-color: #fff;

  }

  ::v-deep .el-drawer__container {
    position: relative;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
    background: aliceblue;
    background-color: rgb(38 38 38 / 70%);
  }

  #containt .table-detail {
    border-collapse: collapse;
    font-size: 12px;
    border: 1px solid #ededed;
  }

  .btn {
    text-align: center;
  }

  //   3个标签
  .information {
    padding: 0px 10px;
    background-color: #E1F2FF;
    color: #268AEA;
    border-radius: 3px;
    margin: 0 5px;
    font-size: 15px;
  }

  //   每个分支
  .d-item {
    border: 1px solid #ededed;
    padding-bottom: 5px;

    .title b {
      display: inline-block;
      line-height: 20px;
      font-size: 13px;
      font-weight: 600;
      margin-right: 84px;
      vertical-align: middle;
      color: rgb(42, 100, 148);
      position: relative;
      z-index: 2;
      background: rgba(42, 100, 148, 0.16);
      margin-left: 0px;
      margin-bottom: 8px;
      padding-left: 12px;
      padding-right: 14px;
      border-radius: 0px 28px 28px 0px;
    }

    .table-detail tr {
      margin-bottom: 10px;
      display: block;

      th {
        font-weight: 400;
        text-align: right;
        width: 7vw !important;
        font-size: 12px;
        position: relative;
        padding: 0 5px 0 4px;
        color: rgba(86, 86, 86, 0.96);
      }

      td {
        font-weight: 400;
        // text-align: right;
        width: 10vw !important;
        font-size: 12px;
        position: relative;
        padding: 0 0px 0 4px;
        color: rgba(0, 0, 0, );
      }
    }
  }

  ::v-deep .el-image__preview {
    width: 60px !important;
    height: 60px !important;
  }

  .pic_main {
    display: flex;
    margin-left: 20px;
    margin-top: 10px;

    .pic_item {
      display: flex;
      margin-right: 40px;

      span {
        white-space: nowrap;
        line-height: 60px;
        font-size: 12px;
        color: rgba(86, 86, 86, 0.96);
        font-weight: 400;

      }
    }
  }

  // 本单费用位置
  .expense {
    position: absolute;
    right: 20%;
    margin-top: 5px;
    color: #00c4b3;
    font-size: 13px;
  }

  // 滚动条样式

  /* 滚动条 */
  ::-webkit-scrollbar {
    width: 5px;
    height: 12px;
  }

  /* 滚动槽 */
  ::-webkit-scrollbar-track {
    border-radius: 0px;
    // background: rgba(224, 7, 7, 0.05);
  }

  /* 滚动条滑块 */
  ::-webkit-scrollbar-thumb {
    border-radius: 00px;
    background: #cfcece;
  }

  // 步骤条 圆的位置
  ::v-deep .el-timeline-item__node--normal {
    left: 0px !important;
    width: 12px;
    height: 12px;
  }

  ::v-deep .el-step__title {
    font-size: 13px !important;
    line-height: 38px;
  }
}</style>
